import axios from "axios";
import { Toaster } from "../utility/Toaster";
import i18n from "../utility/i18n";

const axiosInstance = axios.create({});

const IGNORED_ERRORS = [
  "Unknown Error",
  "No Billing cut found",
  "No data found",
  "Active payor not found",
  "Please try later",
  "Not Found",
  "Failed to fetch",
  "Unexpected token '<',",
  '"id" is required',
  "Network Error",
  "Request aborted",
  "Request Aborted",
  "OK",
];

// helper: safely extract message from any error shape
const getErrorMessage = (err) => {
  return (
    err?.response?.data?.message ||
    err?.response?.data?.error ||
    err?.message ||
    ""
  );
};

// helper: ignore if message contains any ignored phrase
const shouldIgnore = (msg) => {
  const m = String(msg || "").toLowerCase();
  return IGNORED_ERRORS.some((x) => m.includes(String(x).toLowerCase()));
};

const isLatitudeNumberValidationError = (msg) => {
  const normalized = String(msg || "").toLowerCase().replace(/\s+/g, " ").trim();
  return normalized.includes("latitude") && normalized.includes("must be a number");
};

axiosInstance.interceptors.request.use((config) => {
  const evvUrl =
    localStorage.getItem("evvUrl") ||
    process.env.REACT_APP_BASE_URL ||
    `https://backend.revivingcare.us:3306/v1/`;
  config.baseURL = evvUrl;

  // always refresh token per request (not only once at import time)
  const token = localStorage.getItem("token");
  if (token) config.headers.Token = token;
  else if (config.headers?.Token) delete config.headers.Token;

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // 401 handling
    if (error?.response?.status === 401) {
      localStorage.setItem("status", "401");
      window.dispatchEvent(new Event("storage"));
      // reject so calling code knows request failed
      return Promise.reject(error);
    }

    const msg = getErrorMessage(error);

    if (isLatitudeNumberValidationError(msg)) {
      Toaster(
        "error",
        "Error",
        i18n.t("Your device is unable to pick your location, Please check your browser settings")
      );
      return Promise.reject(error);
    }

    // ✅ bypass these errors (no toaster)
    if (shouldIgnore(msg)) {
      // either reject silently OR resolve with a safe value
      return Promise.reject(error); // most common: fail silently (no toaster)
      // return Promise.resolve({ data: null }); // optional alternative
    }

    // normal toaster behavior
    if (error?.response) {
      Toaster("error", msg || "Request Failed", "");
    }
    // else if (error?.request) {
    //   Toaster(
    //     "error",
    //     "Network Error",
    //     "Please check your internet connection"
    //   );
    // } 
    else {
      Toaster("error", msg || "Error", "");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
